
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

// Update a reagent to mark it as unavailable instead of deleting it
export const deleteReagent = async (reagentId: string): Promise<boolean> => {
  try {
    // Get current user
    const { data: sessionData } = await supabase.auth.getSession();
    if (!sessionData.session) {
      toast.error("You must be logged in to remove a reagent");
      return false;
    }

    const userId = sessionData.session.user.id;
    
    // Check if the reagent is referenced in any PENDING swap requests
    // We only block removal if there are pending requests
    const { data: swapRequestsData, error: swapCheckError } = await supabase
      .from("swap_requests")
      .select("id, status")
      .or(`reagent_id.eq.${reagentId},offered_reagent_id.eq.${reagentId}`)
      .eq('status', 'pending');
    
    if (swapCheckError) {
      console.error("Error checking swap requests:", swapCheckError);
      toast.error("Failed to check if reagent is used in swap requests");
      return false;
    }
    
    // If there are pending swap requests, we need to notify the user
    if (swapRequestsData && swapRequestsData.length > 0) {
      toast.error(
        "This reagent cannot be removed because it's part of pending swap requests. " +
        "Cancel or complete the swap requests first."
      );
      return false;
    }
    
    // Update the reagent to set available = false instead of deleting it
    const { error } = await supabase
      .from("reagents")
      .update({ available: false })
      .eq("id", reagentId)
      .eq("user_id", userId);

    if (error) {
      console.error("Error removing reagent:", error);
      toast.error("Failed to remove reagent");
      return false;
    }

    toast.success("Reagent removed successfully");
    return true;
  } catch (error) {
    console.error("Exception in deleteReagent:", error);
    toast.error("An unexpected error occurred");
    return false;
  }
};
